/**
 * Created by yi on 2017-01-06.
 */
export const incrementCounter = function ({ dispatch, state }) {

};



// WEBPACK FOOTER //
// ./src/vuex/actions.js